import { BONDS, RATES } from "network/endpoints";
import ewbApi from "network/ewbApi";

//#region
export const fetchAutoLoansBrandNew = async () =>
  ewbApi.get(RATES.autoLoansBrandNew);

export const fetchAutoLoansSecondHand = async () =>
  ewbApi.get(RATES.autoLoansSecondHand);
//#endregion

//#region Personal Rates
export const fetchPersonalRatesWithCreditCards = async () =>
  await ewbApi.get(RATES.personalLoanRatesWithCC);

export const fetchPersonalRatesWithoutCreditCards = async () =>
  await ewbApi.get(RATES.personalLoanRatesWithoutCC);

//#endregion

//#region Top Bond Picks
export const fetchTopBondPicksRates = async () =>
  await ewbApi.get(BONDS.topBondsPicks);

export const fetchTopBondPicksSubtextData = async () =>
  await ewbApi.get(BONDS.topBondsPicksSubtext);

//#endregion

//#region Time Deposit Rates
export const fetchPesoTimeDepositRates = async () =>
  await ewbApi.get(RATES.pesoTimeDepositRates);

export const fetchLongTermPesoTimeDepositRates = async () =>
  await ewbApi.get(RATES.longTermPesoTimeDepositRates);

export const fetchLongTermPesoTimeDepositRatesFloating = async () =>
  await ewbApi.get(RATES.longTermPesoRateFloating);

export const fetchUSDTimeDepositRate = async () =>
  await ewbApi.get(RATES.usdTimeDepositRate);

export const fetchLongTermUSDTimeDepositRate = async () =>
  await ewbApi.get(RATES.longTermUsdTimeDepositRate);

export const fetchTimeDepositRatesValidity = async () =>
  await ewbApi.get(RATES.timeDepositRateValidity);

export const fetchRmbTimeDepositRate = async () =>
  await ewbApi.get(RATES.rmbTimeDepositRate);

export const fetchEuroTimeDepositRate = async () =>
  await ewbApi.get(RATES.euroTimeDepositRate);

export const fetchJPYTimeDepositRate = async () =>
  await ewbApi.get(RATES.jpyTimeDepositRates);

export const fetchSGDDepositRate = async () =>
  await ewbApi.get(RATES.sgdTimeDepositRates);

export const fetchAUDTimeDepositRate = async () =>
  await ewbApi.get(RATES.audTimeDepositRates);

//#endregion

//#region Deposit Rates
export const fetchPesoSavingRate = async () =>
  await ewbApi.get(RATES.pesoSavingRate);

export const fetchTierredDepositRates = async () =>
  await ewbApi.get(RATES.tierredDepositRates);

export const fetchPesoCheckingRate = async () =>
  await ewbApi.get(RATES.pesoCheckingRate);

export const fetchForeignCurrencySavingsRate = async () =>
  await ewbApi.get(RATES.foreignCurrencySavingsRate);

//#endregion

//#region Home Loan Rates

export const fetchHomeLoanRates = async () =>
  await ewbApi.get(RATES.homeLoanRates);

//#endregion
